import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Card, Button } from 'react-bootstrap';
import { BiArrowBack } from 'react-icons/bi';

import { usePokCore } from '../../../common/hooks/usePokCore';
import { useTranslation } from '../../../common/hooks/useTranslation';
import {
  GetSurveyAnswersByClientSurveyIdDto,
  ResponseError,
} from '../../../common/pokCore/autogenerated/pokApiClient';
import FormSkeleton from '../../../app/components/FormSkeleton';
import { useNotifications } from '../../../common/hooks/useNotifications';
import { SurveyAnswerSearch } from '../../components/ClientSurveys/SurveyAnswerSearch';

export const SurveyAnswerView: React.FC = () => {
  const { clientSurveyId } = useParams<{ clientSurveyId: string }>();
  const pok = usePokCore();
  const { t, tk } = useTranslation('administrationLng');
  const navigate = useNavigate();
  const notifications = useNotifications();
  const lang = pok.getLanguage();

  const [loading, setLoading] = useState(true);
  const [questionsWithAnswers, setQuestionsWithAnswers] =
    useState<GetSurveyAnswersByClientSurveyIdDto>();

  useEffect(() => {
    if (!clientSurveyId) {
      return;
    }
    setLoading(true);
    pok.surveys
      .getQuestionsWithAnswers(clientSurveyId)
      .then(data => {
        setQuestionsWithAnswers(data);
      })
      .catch((error: ResponseError) => {
        notifications.caughtError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [clientSurveyId, pok.surveys, notifications]);

  const handleBack = () => {
    void navigate(-1);
  };

  return (
    <Card className="main-card">
      <Card.Body className="m-3">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <Card.Title className="mb-0">
            <Button
              variant="link"
              className="text-decoration-none ps-0 text-dark"
              onClick={handleBack}
            >
              <BiArrowBack size={24} />
            </Button>
            {t(tk.survey.survey)}:{' '}
            <b>
              {lang === 'PL'
                ? questionsWithAnswers?.surveyNamePl
                : questionsWithAnswers?.surveyNameEn}
            </b>
            <br />
            {t(tk.common.client)}: <b>{questionsWithAnswers?.clientName}</b>
          </Card.Title>
        </div>

        {loading ? (
          <FormSkeleton />
        ) : (
          <SurveyAnswerSearch
            data={questionsWithAnswers?.questionsWithAnswers || []}
          />
        )}
      </Card.Body>
    </Card>
  );
};
